import ApiService from "../ApiService";
const { REACT_APP_REST_ENDPOINT } = process.env;
const VOUCHER_CONTROLLER_ENDPOINT = `${REACT_APP_REST_ENDPOINT}/voucher`;

const VoucherService = {
  findByIdAgenzia(id_agenzia) {
    const url = `${VOUCHER_CONTROLLER_ENDPOINT}/findByIdAgenzia`;
    return new Promise((resolve, reject) => {
      ApiService.postRequest(resolve, reject, url, { id_agenzia });
    });
  },

  getSummaryByIdAgenzia(id_agenzia) {
    const url = `${VOUCHER_CONTROLLER_ENDPOINT}/summaryByAgenzia`;
    return new Promise((resolve, reject) => {
      ApiService.postRequest(resolve, reject, url, { id_agenzia });
    });
  },

  // --- NUOVO METODO: Cerca voucher per ID SUPERPARTNER ---
  findByIdSuperpartner(id_superpartner) {
    const url = `${VOUCHER_CONTROLLER_ENDPOINT}/findByIdSuperpartner`;
    return new Promise((resolve, reject) => {
      ApiService.postRequest(resolve, reject, url, { id_superpartner });
    });
  },

  // --- NUOVO METODO: Riepilogo per ID SUPERPARTNER ---
  getSummaryBySuperpartner(id_superpartner) {
    const url = `${VOUCHER_CONTROLLER_ENDPOINT}/summaryBySuperpartner`;
    return new Promise((resolve, reject) => {
      ApiService.postRequest(resolve, reject, url, { id_superpartner });
    });
  },

  create(data) {
    const url = `${VOUCHER_CONTROLLER_ENDPOINT}/create`;
    return new Promise((resolve, reject) => {
      ApiService.postRequest(resolve, reject, url, data);
    });
  },

  delete(id_utenti_voucher) {
    const url = `${VOUCHER_CONTROLLER_ENDPOINT}/delete`;
    return new Promise((resolve, reject) => {
      ApiService.delete(resolve, reject, url, { id_utenti_voucher });
    });
  },
  
  getUsage(id_utenti_voucher) {
    const url = `${VOUCHER_CONTROLLER_ENDPOINT}/getUsage`;
    return new Promise((resolve, reject) => {
      ApiService.postRequest(resolve, reject, url, { id_utenti_voucher });
    });
  },

  distributeVoucher(data) {
    const url = `${VOUCHER_CONTROLLER_ENDPOINT}/distribute`;
    return new Promise((resolve, reject) => {
      ApiService.postRequest(resolve, reject, url, data);
    });
  },

  findVoucherByIdCorso(data) {
    const url = `${VOUCHER_CONTROLLER_ENDPOINT}/findVoucherByIdCorso`;
    return new Promise((resolve, reject) => {
      ApiService.postRequest(resolve, reject, url, data);
    });
  }
};

export default VoucherService;